import React from 'react';
import PracticeWithUs from './PracticeWithUs';
import Frameworks from './Frameworks';
import Flexibility from './Flexibility';
import EnquiryForm from './EnquiryForm';
import KnowMore from './KnowMore';
import WhyUs from './WhyUs';

const PracticeWithUsContainer: React.FC = () => {
    return (
        <div id="practice-with-us">
            <PracticeWithUs />
            <Frameworks />
            <Flexibility />
            <EnquiryForm />
            <KnowMore />
            <WhyUs />
        </div>
    );
};

export default React.memo(PracticeWithUsContainer);
